import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Footer = () => {
  return (
    <footer>
      <div className="app-footer">
        <div className="footer-row">
          <span className="footer-icon">
            <FontAwesomeIcon icon="phone" />
          </span>
          <p>Información: 609 527 875 · 956 752 909</p>
        </div>

        <div className="footer-row">
          <span className="footer-icon">
            <FontAwesomeIcon icon="envelope" />
          </span>
          <p>info@grupoempresarialandaluz.com</p>
        </div>

        <div className="footer-row">
          <span className="footer-icon">
            <FontAwesomeIcon icon="building" />
          </span>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.google.es/maps/place/Empresa+Auto+la+Valenciana+S.A./@36.6806052,-6.1596823,17z/data=!3m1!4b1!4m5!3m4!1s0xd0de939ce41cb1d:0x6aa7950727dc195e!8m2!3d36.6806052!4d-6.1574936?hl=es"
          >
            Oficina Central (Google Maps)
          </a>
        </div>

        <div className="footer-finance">
          Esta empresa ha obtenido financiación para la adquisición de vehículos
          híbridos, en el marco del plan de recuperación, transformación y
          resiliencia, conforme al RD 983/2021.
          <div className="w-100 mt-2">
            <img
              width={"100%"}
              src="https://documents.enerlence.com/f/67b887e7c449434f9a01/?dl=1"
              alt="banner"
              style={{ maxWidth: "520px" }}
            />
          </div>
        </div>

        <div className="footer-copy">
          Grupo Empresarial Andaluz · {new Date().getFullYear()}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
